/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const userGetMe = /* GraphQL */ `query UserGetMe {
  userGetMe {
    id
    givenName
    familyName
    email
    emailVerified
    roles
    hostTipsEnabled
    hasHostedGame
    organizationId
    username
    role
    accountStatus
    groupsCanRead
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.UserGetMeQueryVariables, APITypes.UserGetMeQuery>;
export const userGet = /* GraphQL */ `query UserGet($id: ID!) {
  userGet(id: $id) {
    id
    givenName
    familyName
    email
    emailVerified
    roles
    hostTipsEnabled
    hasHostedGame
    organizationId
    username
    role
    accountStatus
    groupsCanRead
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.UserGetQueryVariables, APITypes.UserGetQuery>;
export const userList = /* GraphQL */ `query UserList {
  userList {
    id
    givenName
    familyName
    email
    emailVerified
    roles
    hostTipsEnabled
    hasHostedGame
    organizationId
    username
    role
    accountStatus
    groupsCanRead
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.UserListQueryVariables, APITypes.UserListQuery>;
export const userListByOrganization = /* GraphQL */ `query UserListByOrganization($organizationId: String!) {
  userListByOrganization(organizationId: $organizationId) {
    id
    givenName
    familyName
    email
    emailVerified
    roles
    hostTipsEnabled
    hasHostedGame
    organizationId
    username
    role
    accountStatus
    groupsCanRead
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserListByOrganizationQueryVariables,
  APITypes.UserListByOrganizationQuery
>;
export const listOrganizationUsersFiltered = /* GraphQL */ `query ListOrganizationUsersFiltered(
  $filter: OrganizationUserFilter
  $limit: Int
  $nextToken: String
) {
  listOrganizationUsersFiltered(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      givenName
      familyName
      email
      emailVerified
      roles
      hostTipsEnabled
      hasHostedGame
      organizationId
      username
      role
      accountStatus
      groupsCanRead
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrganizationUsersFilteredQueryVariables,
  APITypes.ListOrganizationUsersFilteredQuery
>;
export const userCountByOrganization = /* GraphQL */ `query UserCountByOrganization($organizationId: ID!) {
  userCountByOrganization(organizationId: $organizationId) {
    adminCount
    hostCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserCountByOrganizationQueryVariables,
  APITypes.UserCountByOrganizationQuery
>;
export const userCountByOrganizationAndRole = /* GraphQL */ `query UserCountByOrganizationAndRole($organizationId: ID!, $role: RoleType!) {
  userCountByOrganizationAndRole(organizationId: $organizationId, role: $role)
}
` as GeneratedQuery<
  APITypes.UserCountByOrganizationAndRoleQueryVariables,
  APITypes.UserCountByOrganizationAndRoleQuery
>;
export const userCountsByOrganization = /* GraphQL */ `query UserCountsByOrganization($organizationIds: [ID!]!) {
  userCountsByOrganization(organizationIds: $organizationIds) {
    organizationId
    count
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserCountsByOrganizationQueryVariables,
  APITypes.UserCountsByOrganizationQuery
>;
export const sessionGet = /* GraphQL */ `query SessionGet($id: ID!) {
  sessionGet(id: $id) {
    id
    hostId
    data {
      status
      players {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      rounds {
        id
        index
        isCurrent
        isLast
        promptId
        artwork {
          id
          drawing
          playerId
          __typename
        }
        __typename
      }
      questionType
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SessionGetQueryVariables,
  APITypes.SessionGetQuery
>;
export const sessionList = /* GraphQL */ `query SessionList {
  sessionList {
    id
    hostId
    data {
      status
      players {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      rounds {
        id
        index
        isCurrent
        isLast
        promptId
        artwork {
          id
          drawing
          playerId
          __typename
        }
        __typename
      }
      questionType
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.SessionListQueryVariables,
  APITypes.SessionListQuery
>;
export const gamePackGet = /* GraphQL */ `query GamePackGet($id: ID!) {
  gamePackGet(id: $id) {
    id
    name
    description
    category1
    category2
    category3
    icon
    palette
    isFeatured
    showInDiscover
    isNew
    order
    groups
    status
    prompts {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organizations {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GamePackGetQueryVariables,
  APITypes.GamePackGetQuery
>;
export const gamePackList = /* GraphQL */ `query GamePackList {
  gamePackList {
    id
    name
    description
    category1
    category2
    category3
    icon
    palette
    isFeatured
    showInDiscover
    isNew
    order
    groups
    status
    prompts {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organizations {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GamePackListQueryVariables,
  APITypes.GamePackListQuery
>;
export const promptGet = /* GraphQL */ `query PromptGet($id: ID!) {
  promptGet(id: $id) {
    id
    text
    subdomain
    deletedAt
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.PromptGetQueryVariables, APITypes.PromptGetQuery>;
export const promptList = /* GraphQL */ `query PromptList {
  promptList {
    id
    text
    subdomain
    deletedAt
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackPrompts {
      id
      promptId
      gamePackId
      prompt {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PromptListQueryVariables,
  APITypes.PromptListQuery
>;
export const organizationGetMe = /* GraphQL */ `query OrganizationGetMe {
  organizationGetMe {
    id
    name
    tenant
    subdomain
    emailDomains
    groupsCanRead
    organizationActive
    hostLicenses
    adminLicenses
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    activeUsers
    activeHosts
    activeAdmins
    onFreeTrial
    freeTrialExpiration
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrganizationGetMeQueryVariables,
  APITypes.OrganizationGetMeQuery
>;
export const organizationGet = /* GraphQL */ `query OrganizationGet($id: ID!) {
  organizationGet(id: $id) {
    id
    name
    tenant
    subdomain
    emailDomains
    groupsCanRead
    organizationActive
    hostLicenses
    adminLicenses
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    activeUsers
    activeHosts
    activeAdmins
    onFreeTrial
    freeTrialExpiration
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrganizationGetQueryVariables,
  APITypes.OrganizationGetQuery
>;
export const organizationGetByTenant = /* GraphQL */ `query OrganizationGetByTenant($tenant: String!) {
  organizationGetByTenant(tenant: $tenant) {
    id
    name
    tenant
    subdomain
    emailDomains
    groupsCanRead
    organizationActive
    hostLicenses
    adminLicenses
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    activeUsers
    activeHosts
    activeAdmins
    onFreeTrial
    freeTrialExpiration
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrganizationGetByTenantQueryVariables,
  APITypes.OrganizationGetByTenantQuery
>;
export const organizationGetByName = /* GraphQL */ `query OrganizationGetByName($name: String!) {
  organizationGetByName(name: $name) {
    id
    name
    tenant
    subdomain
    emailDomains
    groupsCanRead
    organizationActive
    hostLicenses
    adminLicenses
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    activeUsers
    activeHosts
    activeAdmins
    onFreeTrial
    freeTrialExpiration
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrganizationGetByNameQueryVariables,
  APITypes.OrganizationGetByNameQuery
>;
export const organizationList = /* GraphQL */ `query OrganizationList {
  organizationList {
    id
    name
    tenant
    subdomain
    emailDomains
    groupsCanRead
    organizationActive
    hostLicenses
    adminLicenses
    gamePacks {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePackOrganizations {
      id
      gamePackId
      organizationId
      gamePack {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organization {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    activeUsers
    activeHosts
    activeAdmins
    onFreeTrial
    freeTrialExpiration
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrganizationListQueryVariables,
  APITypes.OrganizationListQuery
>;
export const organizationPublicList = /* GraphQL */ `query OrganizationPublicList {
  organizationPublicList {
    id
    name
    subdomain
    tenant
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrganizationPublicListQueryVariables,
  APITypes.OrganizationPublicListQuery
>;
export const playerGet = /* GraphQL */ `query PlayerGet($id: ID!) {
  playerGet(id: $id) {
    id
    name
    gameStatus
    connectionStatus
    feelingBefore
    feelingAfter
    question
    questionAnswer
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.PlayerGetQueryVariables, APITypes.PlayerGetQuery>;
export const playerList = /* GraphQL */ `query PlayerList($sessionId: ID!) {
  playerList(sessionId: $sessionId) {
    id
    name
    gameStatus
    connectionStatus
    feelingBefore
    feelingAfter
    question
    questionAnswer
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    organizationId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlayerListQueryVariables,
  APITypes.PlayerListQuery
>;
export const gameGet = /* GraphQL */ `query GameGet($id: ID!) {
  gameGet(id: $id) {
    id
    promptText
    promptGamePackId
    status
    gameIndex
    isCurrent
    isLast
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GameGetQueryVariables, APITypes.GameGetQuery>;
export const gameList = /* GraphQL */ `query GameList($sessionId: ID!) {
  gameList(sessionId: $sessionId) {
    id
    promptText
    promptGamePackId
    status
    gameIndex
    isCurrent
    isLast
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GameListQueryVariables, APITypes.GameListQuery>;
export const gameGetCurrent = /* GraphQL */ `query GameGetCurrent($sessionId: ID!) {
  gameGetCurrent(sessionId: $sessionId) {
    id
    promptText
    promptGamePackId
    status
    gameIndex
    isCurrent
    isLast
    sessionId
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GameGetCurrentQueryVariables,
  APITypes.GameGetCurrentQuery
>;
export const playerCardGet = /* GraphQL */ `query PlayerCardGet($id: ID!) {
  playerCardGet(id: $id) {
    id
    drawing
    drawingLines
    timesStoryMadeFeelGood
    timesStoryWasRelated
    timesStoryWasShared
    gameId
    playerId
    sessionId
    game {
      id
      promptText
      promptGamePackId
      status
      gameIndex
      isCurrent
      isLast
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    player {
      id
      name
      gameStatus
      connectionStatus
      feelingBefore
      feelingAfter
      question
      questionAnswer
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    artworkReactions {
      id
      reaction
      playerCardId
      playerId
      sessionId
      playerCard {
        id
        drawing
        drawingLines
        timesStoryMadeFeelGood
        timesStoryWasRelated
        timesStoryWasShared
        gameId
        playerId
        sessionId
        game {
          id
          promptText
          promptGamePackId
          status
          gameIndex
          isCurrent
          isLast
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        player {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        artworkReactions {
          id
          reaction
          playerCardId
          playerId
          sessionId
          playerCard {
            id
            drawing
            drawingLines
            timesStoryMadeFeelGood
            timesStoryWasRelated
            timesStoryWasShared
            gameId
            playerId
            sessionId
            createdAt
            updatedAt
            __typename
          }
          player {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      player {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlayerCardGetQueryVariables,
  APITypes.PlayerCardGetQuery
>;
export const playerCardListByGame = /* GraphQL */ `query PlayerCardListByGame($gameId: ID!) {
  playerCardListByGame(gameId: $gameId) {
    id
    drawing
    drawingLines
    timesStoryMadeFeelGood
    timesStoryWasRelated
    timesStoryWasShared
    gameId
    playerId
    sessionId
    game {
      id
      promptText
      promptGamePackId
      status
      gameIndex
      isCurrent
      isLast
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    player {
      id
      name
      gameStatus
      connectionStatus
      feelingBefore
      feelingAfter
      question
      questionAnswer
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    artworkReactions {
      id
      reaction
      playerCardId
      playerId
      sessionId
      playerCard {
        id
        drawing
        drawingLines
        timesStoryMadeFeelGood
        timesStoryWasRelated
        timesStoryWasShared
        gameId
        playerId
        sessionId
        game {
          id
          promptText
          promptGamePackId
          status
          gameIndex
          isCurrent
          isLast
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        player {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        artworkReactions {
          id
          reaction
          playerCardId
          playerId
          sessionId
          playerCard {
            id
            drawing
            drawingLines
            timesStoryMadeFeelGood
            timesStoryWasRelated
            timesStoryWasShared
            gameId
            playerId
            sessionId
            createdAt
            updatedAt
            __typename
          }
          player {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      player {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlayerCardListByGameQueryVariables,
  APITypes.PlayerCardListByGameQuery
>;
export const playerCardListByPlayer = /* GraphQL */ `query PlayerCardListByPlayer($playerId: ID!) {
  playerCardListByPlayer(playerId: $playerId) {
    id
    drawing
    drawingLines
    timesStoryMadeFeelGood
    timesStoryWasRelated
    timesStoryWasShared
    gameId
    playerId
    sessionId
    game {
      id
      promptText
      promptGamePackId
      status
      gameIndex
      isCurrent
      isLast
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    player {
      id
      name
      gameStatus
      connectionStatus
      feelingBefore
      feelingAfter
      question
      questionAnswer
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    artworkReactions {
      id
      reaction
      playerCardId
      playerId
      sessionId
      playerCard {
        id
        drawing
        drawingLines
        timesStoryMadeFeelGood
        timesStoryWasRelated
        timesStoryWasShared
        gameId
        playerId
        sessionId
        game {
          id
          promptText
          promptGamePackId
          status
          gameIndex
          isCurrent
          isLast
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        player {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        artworkReactions {
          id
          reaction
          playerCardId
          playerId
          sessionId
          playerCard {
            id
            drawing
            drawingLines
            timesStoryMadeFeelGood
            timesStoryWasRelated
            timesStoryWasShared
            gameId
            playerId
            sessionId
            createdAt
            updatedAt
            __typename
          }
          player {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      player {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlayerCardListByPlayerQueryVariables,
  APITypes.PlayerCardListByPlayerQuery
>;
export const playerCardListBySession = /* GraphQL */ `query PlayerCardListBySession($sessionId: ID!) {
  playerCardListBySession(sessionId: $sessionId) {
    id
    drawing
    drawingLines
    gameId
    player {
      name
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlayerCardListBySessionQueryVariables,
  APITypes.PlayerCardListBySessionQuery
>;
export const playerCardGetByGameAndPlayer = /* GraphQL */ `query PlayerCardGetByGameAndPlayer($gameId: ID!, $playerId: ID!) {
  playerCardGetByGameAndPlayer(gameId: $gameId, playerId: $playerId) {
    id
    drawing
    drawingLines
    timesStoryMadeFeelGood
    timesStoryWasRelated
    timesStoryWasShared
    gameId
    playerId
    sessionId
    game {
      id
      promptText
      promptGamePackId
      status
      gameIndex
      isCurrent
      isLast
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    player {
      id
      name
      gameStatus
      connectionStatus
      feelingBefore
      feelingAfter
      question
      questionAnswer
      sessionId
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    session {
      id
      hostId
      data {
        status
        players {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        rounds {
          id
          index
          isCurrent
          isLast
          promptId
          artwork {
            id
            drawing
            playerId
            __typename
          }
          __typename
        }
        questionType
        __typename
      }
      organizationId
      createdAt
      updatedAt
      __typename
    }
    artworkReactions {
      id
      reaction
      playerCardId
      playerId
      sessionId
      playerCard {
        id
        drawing
        drawingLines
        timesStoryMadeFeelGood
        timesStoryWasRelated
        timesStoryWasShared
        gameId
        playerId
        sessionId
        game {
          id
          promptText
          promptGamePackId
          status
          gameIndex
          isCurrent
          isLast
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        player {
          id
          name
          gameStatus
          connectionStatus
          feelingBefore
          feelingAfter
          question
          questionAnswer
          sessionId
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        artworkReactions {
          id
          reaction
          playerCardId
          playerId
          sessionId
          playerCard {
            id
            drawing
            drawingLines
            timesStoryMadeFeelGood
            timesStoryWasRelated
            timesStoryWasShared
            gameId
            playerId
            sessionId
            createdAt
            updatedAt
            __typename
          }
          player {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          session {
            id
            hostId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      player {
        id
        name
        gameStatus
        connectionStatus
        feelingBefore
        feelingAfter
        question
        questionAnswer
        sessionId
        session {
          id
          hostId
          data {
            status
            questionType
            __typename
          }
          organizationId
          createdAt
          updatedAt
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      session {
        id
        hostId
        data {
          status
          players {
            id
            name
            gameStatus
            connectionStatus
            feelingBefore
            feelingAfter
            question
            questionAnswer
            sessionId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          rounds {
            id
            index
            isCurrent
            isLast
            promptId
            __typename
          }
          questionType
          __typename
        }
        organizationId
        createdAt
        updatedAt
        __typename
      }
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlayerCardGetByGameAndPlayerQueryVariables,
  APITypes.PlayerCardGetByGameAndPlayerQuery
>;
export const playerCardGetReactionCounts = /* GraphQL */ `query PlayerCardGetReactionCounts($id: ID!) {
  playerCardGetReactionCounts(id: $id) {
    feelGood
    related
    shared
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PlayerCardGetReactionCountsQueryVariables,
  APITypes.PlayerCardGetReactionCountsQuery
>;
export const gamePackPromptsGet = /* GraphQL */ `query GamePackPromptsGet($id: ID!) {
  gamePackPromptsGet(id: $id) {
    id
    promptId
    gamePackId
    prompt {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GamePackPromptsGetQueryVariables,
  APITypes.GamePackPromptsGetQuery
>;
export const gamePackPromptsList = /* GraphQL */ `query GamePackPromptsList {
  gamePackPromptsList {
    id
    promptId
    gamePackId
    prompt {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GamePackPromptsListQueryVariables,
  APITypes.GamePackPromptsListQuery
>;
export const gamePackPromptsByPromptId = /* GraphQL */ `query GamePackPromptsByPromptId($promptId: ID!) {
  gamePackPromptsByPromptId(promptId: $promptId) {
    id
    promptId
    gamePackId
    prompt {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GamePackPromptsByPromptIdQueryVariables,
  APITypes.GamePackPromptsByPromptIdQuery
>;
export const gamePackPromptsByGamePackId = /* GraphQL */ `query GamePackPromptsByGamePackId($gamePackId: ID!) {
  gamePackPromptsByGamePackId(gamePackId: $gamePackId) {
    id
    promptId
    gamePackId
    prompt {
      id
      text
      subdomain
      deletedAt
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GamePackPromptsByGamePackIdQueryVariables,
  APITypes.GamePackPromptsByGamePackIdQuery
>;
export const gamePackOrganizationsGet = /* GraphQL */ `query GamePackOrganizationsGet($id: ID!) {
  gamePackOrganizationsGet(id: $id) {
    id
    gamePackId
    organizationId
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organization {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GamePackOrganizationsGetQueryVariables,
  APITypes.GamePackOrganizationsGetQuery
>;
export const gamePackOrganizationsList = /* GraphQL */ `query GamePackOrganizationsList {
  gamePackOrganizationsList {
    id
    gamePackId
    organizationId
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organization {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GamePackOrganizationsListQueryVariables,
  APITypes.GamePackOrganizationsListQuery
>;
export const gamePackOrganizationsByGamePackId = /* GraphQL */ `query GamePackOrganizationsByGamePackId($gamePackId: ID!) {
  gamePackOrganizationsByGamePackId(gamePackId: $gamePackId) {
    id
    gamePackId
    organizationId
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organization {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GamePackOrganizationsByGamePackIdQueryVariables,
  APITypes.GamePackOrganizationsByGamePackIdQuery
>;
export const gamePackOrganizationsByOrganizationId = /* GraphQL */ `query GamePackOrganizationsByOrganizationId($organizationId: ID!) {
  gamePackOrganizationsByOrganizationId(organizationId: $organizationId) {
    id
    gamePackId
    organizationId
    gamePack {
      id
      name
      description
      category1
      category2
      category3
      icon
      palette
      isFeatured
      showInDiscover
      isNew
      order
      groups
      status
      prompts {
        id
        text
        subdomain
        deletedAt
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      organizations {
        id
        name
        tenant
        subdomain
        emailDomains
        groupsCanRead
        organizationActive
        hostLicenses
        adminLicenses
        gamePacks {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        activeUsers
        activeHosts
        activeAdmins
        onFreeTrial
        freeTrialExpiration
        createdAt
        updatedAt
        __typename
      }
      gamePackPrompts {
        id
        promptId
        gamePackId
        prompt {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    organization {
      id
      name
      tenant
      subdomain
      emailDomains
      groupsCanRead
      organizationActive
      hostLicenses
      adminLicenses
      gamePacks {
        id
        name
        description
        category1
        category2
        category3
        icon
        palette
        isFeatured
        showInDiscover
        isNew
        order
        groups
        status
        prompts {
          id
          text
          subdomain
          deletedAt
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organizations {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        gamePackPrompts {
          id
          promptId
          gamePackId
          prompt {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        gamePackOrganizations {
          id
          gamePackId
          organizationId
          gamePack {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          organization {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      gamePackOrganizations {
        id
        gamePackId
        organizationId
        gamePack {
          id
          name
          description
          category1
          category2
          category3
          icon
          palette
          isFeatured
          showInDiscover
          isNew
          order
          groups
          status
          prompts {
            id
            text
            subdomain
            deletedAt
            createdAt
            updatedAt
            __typename
          }
          organizations {
            id
            name
            tenant
            subdomain
            emailDomains
            groupsCanRead
            organizationActive
            hostLicenses
            adminLicenses
            activeUsers
            activeHosts
            activeAdmins
            onFreeTrial
            freeTrialExpiration
            createdAt
            updatedAt
            __typename
          }
          gamePackPrompts {
            id
            promptId
            gamePackId
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        organization {
          id
          name
          tenant
          subdomain
          emailDomains
          groupsCanRead
          organizationActive
          hostLicenses
          adminLicenses
          gamePacks {
            id
            name
            description
            category1
            category2
            category3
            icon
            palette
            isFeatured
            showInDiscover
            isNew
            order
            groups
            status
            createdAt
            updatedAt
            __typename
          }
          gamePackOrganizations {
            id
            gamePackId
            organizationId
            createdAt
            updatedAt
            __typename
          }
          activeUsers
          activeHosts
          activeAdmins
          onFreeTrial
          freeTrialExpiration
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      activeUsers
      activeHosts
      activeAdmins
      onFreeTrial
      freeTrialExpiration
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GamePackOrganizationsByOrganizationIdQueryVariables,
  APITypes.GamePackOrganizationsByOrganizationIdQuery
>;
export const artworkReactionList = /* GraphQL */ `query ArtworkReactionList($filter: ArtworkReactionFilterInput!) {
  artworkReactionList(filter: $filter) {
    reaction
    playerCardId
    playerId
    sessionId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ArtworkReactionListQueryVariables,
  APITypes.ArtworkReactionListQuery
>;
export const artworkReactionCountBySession = /* GraphQL */ `query ArtworkReactionCountBySession($sessionId: ID!) {
  artworkReactionCountBySession(sessionId: $sessionId) {
    reactionType
    count
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ArtworkReactionCountBySessionQueryVariables,
  APITypes.ArtworkReactionCountBySessionQuery
>;
export const metricsByTenant = /* GraphQL */ `query MetricsByTenant($tenantId: ID!) {
  metricsByTenant(tenantId: $tenantId) {
    updatedAt
    sentimentIncrease
    totalPlayers
    sentimentCount
    gamesHosted
    questionScore {
      label
      value
      __typename
    }
    reactionScore {
      label
      value
      __typename
    }
    totalHosts
    storiesShared
    medianRoundTime
    popularPrompt
    popularGamePack
    avgPlayersPerGame
    avgRoundsPerGame
    avgGameLengthMin
    activityTimeline {
      label
      value
      __typename
    }
    customPromptsCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MetricsByTenantQueryVariables,
  APITypes.MetricsByTenantQuery
>;
export const metricsByHost = /* GraphQL */ `query MetricsByHost($hostId: ID!) {
  metricsByHost(hostId: $hostId) {
    updatedAt
    sentimentIncrease
    totalPlayers
    sentimentCount
    gamesHosted
    questionScore {
      label
      value
      __typename
    }
    reactionScore {
      label
      value
      __typename
    }
    totalHosts
    storiesShared
    medianRoundTime
    popularPrompt
    popularGamePack
    avgPlayersPerGame
    avgRoundsPerGame
    avgGameLengthMin
    activityTimeline {
      label
      value
      __typename
    }
    customPromptsCount
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MetricsByHostQueryVariables,
  APITypes.MetricsByHostQuery
>;
export const asyncTask = /* GraphQL */ `query AsyncTask($id: ID!) {
  asyncTask(id: $id) {
    id
    type
    status
    payload
    result
    error
    createdBy
    tenant
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.AsyncTaskQueryVariables, APITypes.AsyncTaskQuery>;
